import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";

export interface IDocumentPageData {
    canEditDocuments: boolean;
    canEditProperties: boolean;
    canEditRootFolderProperties: boolean;
    keywords: IIdTitle[];
}

export class DocumentPageData implements IDocumentPageData {
    canEditDocuments: boolean;
    canEditProperties: boolean;
    canEditRootFolderProperties: boolean;
    keywords: IdTitle[];

    constructor();
    constructor(obj: IDocumentPageData);
    constructor(obj?: any) {
        this.canEditDocuments = obj && obj.canEditDocuments || false;
        this.canEditProperties = obj && obj.canEditProperties || false;
        this.canEditRootFolderProperties = obj && obj.canEditRootFolderProperties || false;
        this.keywords = Base.getTypedArray(obj ? obj.keywords : null, IdTitle);
    }
}
